import { useContext, useMemo } from 'react';
import Checkbox from '@/FiltersMenu/Checkbox';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { ModelFacet } from '~/contracts/FacetData';
import Model from './Model';
import LabelWithCount from '../LabelWithCount';
import { ModelWrapper } from '../styles';

type OwnProps = {
  count: number;
  make: string;
  models: Array<ModelFacet>;
};

const Make = ({ count, make, models = [] }: OwnProps) => {
  const { appliedFilters, updateMakes } = useContext(AppliedFiltersContext);

  const isSelected = useMemo(
    () =>
      appliedFilters?.makes?.some(appliedMake => appliedMake.name === make) ??
      false,
    [appliedFilters.makes, make]
  );

  const hasModelCounts = useMemo(
    () => models.some(model => model.count > 0),
    [models]
  );

  return (
    <>
      <Checkbox
        facet="make"
        filter={make}
        id={`make-${make}`}
        checked={isSelected}
        onChange={() => updateMakes({ name: make })}
        label={<LabelWithCount count={count} displayName={make} />}
      />
      {isSelected && (
        <div className="px-32">
          <p className="mb-16 t-body-s text-grey-5">Models</p>
          <ModelWrapper>
            {models?.map(({ key, count: modelCount, modelId }) => (
              <Model
                key={`${make} ${key} ${modelId}`}
                count={modelCount}
                make={make}
                model={key}
                showCount={hasModelCounts}
              />
            ))}
          </ModelWrapper>
        </div>
      )}
    </>
  );
};

export default Make;
